import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";

import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
import { ModuleRegistry } from "ag-grid-enterprise";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider.tsx";
import { ContactProvider } from "./context/ContactProvider.tsx";
import { SidebarProvider } from "./context/SidebarProvider.tsx";

import App from "./App.tsx";
import { ReferenceProvider } from "./context/ReferenceProvider.tsx";
import { ThemeProvider } from "./context/ThemeProvider.tsx";
import { ReportProvider } from "./context/ReportProvider.tsx";

ModuleRegistry.registerModules([
  AllEnterpriseModule.with(AgChartsEnterpriseModule),
]);

LicenseManager.setLicenseKey(
  "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-087451}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{EML_Payments_NA}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{EML-NA-Reporting}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{EML-NA-Reporting}_need_to_be_licensed___{EML-NA-Reporting}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{5_May_2026}____[v3]_[0102]_MTc3NzkzNTYwMDAwMA==dc212aa3c0c4c02a5e71814edd869cae"
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>      
      <ContactProvider>
        <SidebarProvider>
          <ReferenceProvider>
            <AuthProvider>
              <ReportProvider>
                <ThemeProvider>
                  <App />
                </ThemeProvider>
              </ReportProvider>
            </AuthProvider>
          </ReferenceProvider>
        </SidebarProvider>
      </ContactProvider>      
    </BrowserRouter>
  </StrictMode>
);
